import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SharedModule } from "../../../shared/shared.module";
import { CreateQuoteComponent } from "./create-quote/create-quote.component";
import { ManageQuoteComponent } from "./manage-quote/manage-quote.component";
import { QuotesComponent } from "./quote.component";

@NgModule({
  declarations: [QuotesComponent, CreateQuoteComponent, ManageQuoteComponent],
  imports: [CoreModule, SharedModule],
  exports: [QuotesComponent, CreateQuoteComponent, ManageQuoteComponent],
})
export class QuoteModule {}
